import {defineStore} from 'pinia';
import {ref} from "vue";
import { useTitle } from '@vueuse/core';

export const useAppStore = defineStore('appStore', () => {

    const title = useTitle('', {titleTemplate: '%s - 云资源监控中心'});

    const error = ref<unknown | null>(null);


    const setTitle = (newTitle: string): void => {
        title.value = newTitle;
    }

    const setError = (err: unknown | null): void => {
        error.value = err;
    }

    return {
        error,
        setTitle,
        setError,
    }
});
